
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';


const NotificationComponent = lazy(() => import('../../pages/Notification/containers/NotificationPageContainer'));
const NotificationDetailComponent = lazy(() => import('../../pages/Notification/containers/NotificationDetailPageContainer'));

const route = [
  {
    path: ROUTERS.NOTIFICATION,
    title: 'Notification',
    exact: true,
    public: false,
    component: <NotificationComponent />,
  },
  {
    path: ROUTERS.NOTIFICATION_DETAIL,
    title: 'Notification Detail',
    exact: true,
    public: false,
    component: <NotificationDetailComponent />,
  }
];

export default route;